<div *ngIf="errorAlertFlag" id="overlay" (click)="resetAlerts()"></div>
<div id="alertContainer">  
    <div *ngFor="let alert of alerts" class="{{alertStyle}} alert customAlert">
        <span class="alertIcon {{alertIconMaterial}}"></span>
        {{alert.message}}
        <a class="close" (click)="removeAlert(alert)">&times;</a>
    </div>
</div>